module.exports = __webpack_public_path__ + "img/zhengpin.8c8add37.png";